import { ShieldCheck } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { RegulatoryVendorPage } from './pages/RegulatoryVendorPage'
import { RegulatoryRequestPage } from './pages/RegulatoryRequestPage'
import { useRegulatoryVendorNavBadge } from './nav-badge'

/**
 * Regulatory — Vendor (2026-05-29).
 *
 * Vendor-facing regulatory requests (documentation requests, country-of-
 * origin / change notifications, vendor compliance). Fully separate sibling
 * of Regulatory — Customer: distinct nav entry, distinct board, vendor-only
 * stage set (New → In Review → Request Sent → Awaiting Vendor Response →
 * Docs Received → …) + activities. Shares the board via
 * @/shell/services/regulatory.
 */
export default defineModule({
  id: 'regulatory-vendor',
  name: 'Regulatory — Vendor',
  shortName: 'Reg. Vendor',
  icon: ShieldCheck,
  navSection: 'regulatory',
  navOrder: 11,
  urlNamespace: '/regulatory/vendor',
  routes: [
    { path: '/', element: RegulatoryVendorPage, label: 'Regulatory — Vendor' },
    { path: '/$requestId', element: RegulatoryRequestPage, label: 'Regulatory request' },
  ],
  permissions: ['admin', 'operations', 'operations_logistics', 'purchasing', 'regulatory', 'sales'],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g b',
  useNavBadge: useRegulatoryVendorNavBadge,

  commandPaletteEntries: [
    {
      label: 'Go to Regulatory — Vendor',
      keywords: ['regulatory', 'vendor', 'docs', 'country of origin', 'change notification'],
      path: '/',
      group: 'modules',
      shortcut: 'g b',
    },
  ],
})
